import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook } from "lucide-react";
import { CANDIDATE } from "@/data/content";

export const Footer = () => {
  return (
    <footer className="bg-graphite text-cream mt-24" data-testid="site-footer">
      <div className="container-x grid gap-12 py-20 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img
              src={CANDIDATE.logoBadge}
              alt="ROB4MANCH badge"
              className="h-16 w-16 object-contain bg-cream rounded-full p-1"
            />
            <div>
              <h3 className="font-display text-4xl font-black uppercase text-cream leading-none">
                ROB<span className="text-terracotta">4</span>NH
              </h3>
              <p className="overline text-cream/60 mt-2">Hillsborough 40 · Manchester</p>
              <p className="text-[10px] tracking-[0.2em] uppercase text-cream/50 mt-1">Wards 1, 3, 10, 11 &amp; 12</p>
            </div>
          </div>
          <p className="mt-6 max-w-md text-cream/70 leading-relaxed">
            Strong Communities. Secure Future. Bold Solutions. A grassroots campaign for New
            Hampshire State Representative — built by neighbors, accountable to the people of
            Manchester.
          </p>
          <div className="mt-8 flex gap-3">
            <a
              href={`mailto:${CANDIDATE.email}`}
              className="rounded-xl border border-cream/20 p-2 hover:bg-cream/10"
              aria-label="Email"
              data-testid="footer-email-link"
            >
              <Mail size={18} />
            </a>
            <a href="https://www.facebook.com/Rob4NH" target="_blank" rel="noreferrer" className="rounded-xl border border-cream/20 p-2 hover:bg-cream/10" aria-label="Facebook" data-testid="footer-facebook-link">
              <Facebook size={18} />
            </a>
            <a href="https://www.instagram.com/rob4nh" target="_blank" rel="noreferrer" className="rounded-xl border border-cream/20 p-2 hover:bg-cream/10" aria-label="Instagram" data-testid="footer-instagram-link">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-cream/60">Get involved</p>
          <ul className="mt-4 space-y-3 text-cream/80">
            <li><Link to="/volunteer" data-testid="footer-volunteer-link">Volunteer</Link></li>
            <li><Link to="/donate" data-testid="footer-donate-link">Donate</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-cream/60">The campaign</p>
          <ul className="mt-4 space-y-3 text-cream/80">
            <li><Link to="/about" data-testid="footer-about-link">About Rob</Link></li>
            <li><Link to="/issues" data-testid="footer-issues-link">Issues</Link></li>
            <li><Link to="/news" data-testid="footer-news-link">News &amp; Updates</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="container-x flex flex-col md:flex-row justify-between gap-3 py-6 text-xs tracking-wide text-cream/55">
          <span>© {new Date().getFullYear()} {CANDIDATE.committee}. All rights reserved.</span>
          <span className="md:max-w-xl md:text-right">{CANDIDATE.disclaimer}</span>
        </div>
        <div className="container-x pb-6 text-xs text-cream/35">
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-cream/70">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
